import React, { useState, useEffect, useRef } from 'react'

import { TableRowContainer, TableRowHeaderContainer } from './TableRow.styles'

import TableCell from '../TableCell'
import dayjs from 'dayjs'

const TableRow = ({ top, headerRowRef, sticky = false, userSelect, background, isHeader = false, isHeaderFormatted = false, content, children, className, onClick, group, fontSize, cellProps, ...rowProps }) => {
    const [hoverActive, setHoverActive] = useState(false)

    if (isHeaderFormatted)
        return (
            <TableRowHeaderContainer top={top}
                sticky={sticky} ref={headerRowRef} userSelect={userSelect} background={background} className={className} fontSize={fontSize}
                onClick={onClick} onMouseEnter={(e) => setHoverActive(true)} {...rowProps}
                onMouseLeave={(e) => setHoverActive(false)}>{
                    content !== undefined &&
                    Object.keys(content).map((it, index) => {
                        if (!Array.isArray(content[it]))
                            return (
                                <TableCell key={index} content={{ title: it, props: { ...content[it].props } }} />)
                        else {
                            return <></>
                        }
                    })

                }{children}</TableRowHeaderContainer>
        )
    else if (isHeader)
        return (
            <TableRowHeaderContainer
                top={top} sticky={sticky} ref={headerRowRef} userSelect={userSelect} background={background}
                className={className} fontSize={fontSize} onClick={onClick} onMouseEnter={(e) => setHoverActive(true)} {...rowProps}
                onMouseLeave={(e) => setHoverActive(false)}>{
                    content !== undefined &&
                    Object.keys(content).map((it) => {
                        if (!Array.isArray(content[it]))
                            return (
                                <TableCell content={{ title: content[it].title, props: { ...content[it].props } }} />)
                        else {
                            return <></>
                        }
                    })

                }{children}</TableRowHeaderContainer>
        )
    return (
        <TableRowContainer top={top} sticky={sticky} ref={headerRowRef} 
        userSelect={userSelect} background={background} className={className} fontSize={fontSize} onClick={onClick} onMouseEnter={(e) => setHoverActive(true)} {...rowProps}
            onMouseLeave={(e) => setHoverActive(false)}>{
                content !== undefined &&
                Object.keys(content).map((it) => {
                    if (!Array.isArray(content[it]))
                        return (
                            <TableCell content={{ title: content[it].title, props: { ...content[it].props, ...cellProps } }} />)
                    else {
                        return <></>
                    }
                })

            }{children}</TableRowContainer>
    )
}

export default TableRow